var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81367 14.6899L13.1357 5.2212C13.5336 4.71058 13.6751 4.12025 13.5424 3.51916C13.4275 2.97272 13.0914 2.45314 12.5874 2.05898L11.3582 1.08255C10.2882 0.231532 8.96175 0.321116 8.20125 1.29755L7.37883 2.36446C7.27275 2.49793 7.29925 2.69501 7.43192 2.80251C7.43192 2.80251 9.51 4.46872 9.55425 4.50455C9.69575 4.63892 9.80183 4.81808 9.82842 5.03307C9.87258 5.45411 9.58075 5.84827 9.1475 5.90202C8.94408 5.92889 8.7495 5.86618 8.60808 5.74972L6.42383 4.01185C6.31772 3.93212 6.15854 3.94915 6.07011 4.05664L0.879282 10.7753C0.543249 11.1962 0.42829 11.7427 0.543249 12.2712L1.20647 15.1467C1.24184 15.2991 1.37449 15.4066 1.53366 15.4066L4.45185 15.3707C4.98242 15.3617 5.47763 15.1199 5.81367 14.6899ZM9.89975 13.7944H14.6582C15.1224 13.7944 15.5 14.1769 15.5 14.6472C15.5 15.1184 15.1224 15.5 14.6582 15.5H9.89975C9.4355 15.5 9.05792 15.1184 9.05792 14.6472C9.05792 14.1769 9.4355 13.7944 9.89975 13.7944Z",
    fill: "#273043",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditI);
export default __webpack_public_path__ + "static/media/edit-i.549b3fa35103c671f6cf90a77a843f12.svg";
export { ForwardRef as ReactComponent };